








import Webview from '@/webview';

import { dispatchGetHospitalDetail } from '@/store/specialist';
import Component from 'vue-class-component';

@Component
export default class HospitalIntro extends Webview {
  intro = '';

  async created() {
    const { id } = this.$route.params;
    const { description = '暂无简介' } = await dispatchGetHospitalDetail(this.$store, {
      hospitalId: Number(id)
    });
    this.intro = description;
  }
}
